module.exports = __webpack_public_path__ + "img/phoneIcon.aa82e45c.svg";